export class ReferenceVoucherByVoucherKindFilterInfo {
  public ReferencedVoucherKindId?: number;
  public VoucherKindId: number;
  public DetailLedgerId?: number;
  public WarehouseId?: number;
  public WarehouseTransferId?: number;
  public VoucherDate: Date;
  public BranchId?: number;
  public FiscalYearId: number;
}
